'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
const password_form_1 = require("./class/password-form");
const password_hint_1 = require("./class/password_hint");
new password_form_1.default;
new password_hint_1.default;
